export enum ConceptEnum {
    MULTIMEDIA = "070",
    PRODUITS_CULTURELS_SAV = "002",
    BRUN_BLANC_MULTIMEDIA = "019",
    MULTI_ACTIVITE = "077",
    MEUBLES = "081",
    MEUBLES_ELECTROMENAGER = "110",
    MAISON = "121",
    CODE_116 = "116"
}

export class ConceptUtils {
    static getValuesAsList(): string[] {
        return Object.values(ConceptEnum);
    }
}
